document.addEventListener("DOMContentLoaded", () => {
  const productMedia = document.querySelector(".c-product__media");
  const productInfo = document.querySelector(".product__info-container");

  if (!productMedia || !productInfo) return;

  let sidebar = null;

  function initStickySidebar() {
    if (sidebar) {
      sidebar.destroy();
      sidebar = null;
    }

    if (window.innerWidth >= 1000) {
      // まずスティッキー要素のスタイルをリセット
      const stickyElement = document.querySelector(".product__info-container");
      if (stickyElement) {
        stickyElement.style.transform = "";
        stickyElement.style.position = "";
        stickyElement.style.top = "";
      }

      sidebar = new StickySidebar(".product__info-container", {
        containerSelector: ".product__info-container", // より具体的に
        topSpacing: 10,
        bottomSpacing: 0,
        resizeSensor: true,
        minWidth: 1000,
        stickyClass: "is-affixed",
        // 重要：高さ計算を制限
        enableAutoHeight: false,
        // 計算方法を変更
        positionFixed: false,
        useTransform: false,
      });
    }
  }

  // 初期化を遅延
  setTimeout(() => {
    initStickySidebar();
  }, 100);

  // リサイズ時の処理
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initStickySidebar();
    }, 250);
  });

  // 改善された更新関数
  function updateSidebarSafely(delay = 100) {
    if (sidebar) {
      setTimeout(() => {
        try {
          sidebar.updateSticky();
        } catch (e) {
          console.warn("StickySidebar update failed:", e);
          initStickySidebar(); // 失敗時は再初期化
        }
      }, delay);
    }
  }

  // MutationObserver
  const observer = new MutationObserver(() => {
    updateSidebarSafely(50);
  });

  const productForm = document.querySelector(".product-form");
  if (productForm) {
    observer.observe(productForm, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class", "hidden"],
    });
  }

  // イベントハンドラーを統一
  document.addEventListener("variant:changed", () => updateSidebarSafely(150));

  document.addEventListener("click", (e) => {
    if (e.target.matches(".product-tabs__tab")) {
      updateSidebarSafely(400);
    }
    if (
      e.target.matches("#toggleColorBtn") ||
      e.target.closest("#toggleColorBtn")
    ) {
      updateSidebarSafely(900);
    }
    if (
      e.target.closest(
        ".product-tabs__expand-button, .product-tabs__collapse-button"
      )
    ) {
      updateSidebarSafely(900);
    }
  });

  window.addEventListener("load", () => updateSidebarSafely(200));
});
